import type { Copy } from "../types";

export const el: Copy = {
    seo: {
      title: "Υπολογιστής Ηλικίας Οχήματος | έλεγχος ηλικίας με έτος και μήνα",
      description:
        "Ελέγξτε την ακριβή ηλικία ενός οχήματος από το έτος και τον προαιρετικό μήνα κατασκευής. Δείτε έτη, μήνες, ημέρες, συνολικές ημέρες και ορόσημα σε ένα καθαρό εργαλείο.",
      keywords: [
        "υπολογιστής ηλικίας οχήματος",
        "ηλικία αυτοκινήτου",
        "ηλικία οχήματος από έτος",
        "έτος κατασκευής αυτοκινήτου",
        "μήνας κατασκευής οχήματος",
        "πόσο παλιό είναι το αυτοκίνητό μου",
        "έλεγχος ηλικίας οχήματος",
        "υπολογιστής ηλικίας RC",
        "υπολογιστής ημερομηνίας οχήματος",
        "υπολογιστής ηλικίας αυτοκινήτου με μήνα",
        "εναλλακτική mParivahan",
        "εναλλακτική Parivahan",
        "υπολογιστής ηλικίας οχήματος RTO",
        "έλεγχος ηλικίας ταξινόμησης αυτοκινήτου",
        "ηλικία ταξινόμησης οχήματος",
      ],
      faq: [
        {
          question: "Τι κάνει αυτός ο υπολογιστής;",
          answer:
            "Υπολογίζει την ακριβή ηλικία ενός οχήματος από το επιλεγμένο έτος και τον προαιρετικό μήνα κατασκευής και εμφανίζει έτη, μήνες, ημέρες και πληροφορίες οροσήμων.",
        },
        {
          question: "Γιατί υπάρχει προαιρετικός μήνας;",
          answer:
            "Η επιλογή μήνα κάνει τον υπολογισμό πιο ακριβή. Αν παραλείψετε τον μήνα, η εφαρμογή χρησιμοποιεί τον Ιανουάριο του επιλεγμένου έτους.",
        },
        {
          question: "Μπορώ να επιλέξω μελλοντικό έτος ή μήνα;",
          answer:
            "Όχι. Τα μελλοντικά έτη είναι μπλοκαρισμένα και οι μελλοντικοί μήνες απενεργοποιούνται όταν το επιλεγμένο έτος είναι το τρέχον.",
        },
      ],
    },
    headerTagline: "Εργαλείο οχήματος",
    headerTitle: "Υπολογιστής Ηλικίας Οχήματος",
    reset: "Επαναφορά",
    switchToLight: "Μετάβαση σε ανοιχτό θέμα",
    switchToDark: "Μετάβαση σε σκοτεινό θέμα",
    languageLabel: "Γλώσσα",
    languageEnglish: "Αγγλικά",
    languageHindi: "Χίντι",
    heroEyebrow: "Η ηλικία του αυτοκινήτου, ξεκάθαρα",
    heroTitle: "Ένα καθαρό εργαλείο ημερομηνίας για την ηλικία του οχήματος.",
    heroDescription:
      "Επιλέξτε το έτος κατασκευής. Προσθέστε μήνα μόνο αν θέλετε πιο ακριβές αποτέλεσμα.",
    yearSelectLabel: "Έτος κατασκευής",
    monthSelectLabel: "Μήνας κατασκευής",
    includeMonthLabel: "Συμπερίληψη συγκεκριμένου μήνα για μεγαλύτερη ακρίβεια",
    includeMonthNote:
      "Αν δεν προσθέσετε μήνα, θα χρησιμοποιηθεί ο Ιανουάριος για τον υπολογισμό.",
    yearOnlyBadge: "Μόνο έτος",
    yearMonthBadge: "Έτος + μήνας",
    yearPlaceholder: "Επιλέξτε έτος",
    monthPlaceholder: "Επιλέξτε μήνα",
    inputTitle: "Έτος κατασκευής",
    inputLabel: "Έτος κατασκευής",
    blockedDateNote: "Τα μελλοντικά έτη είναι μπλοκαρισμένα.",
    result: "Αποτέλεσμα",
    vehicleAgeLead: "Το όχημά σας είναι",
    asOfToday: "Σήμερα",
    years: "Έτη",
    months: "Μήνες",
    days: "Ημέρες",
    totalDays: (count) => `${count.toLocaleString("en-IN")} συνολικές ημέρες`,
    ageLabels: { almostNew: "Σχεδόν καινούργιο", modern: "Σύγχρονο", mature: "Ώριμο", classic: "Κλασικό" },
    estimatedValue: {
      high: "Υψηλό δυναμικό μεταπώλησης",
      healthy: "Υγιής διατήρηση αξίας",
      moderate: "Μέτρια απόσβεση",
      collector: "Ενδέχεται να αυξηθεί το ενδιαφέρον συλλεκτών",
    },
    maintenanceTitle: "Συντήρηση",
    maintenance: {
      routine: "Συνήθης σέρβις και φροντίδα OEM",
      watch: "Παρακολουθήστε φρένα, υγρά και ελαστικά",
      plan: "Προγραμματίστε φθορές και ελέγχους",
      specialized: "Η εξειδικευμένη συντήρηση γίνεται πιο σημαντική",
    },
    registrationTitle: "Ταξινόμηση",
    registration: {
      collector: "Σε ορισμένες περιοχές μπορεί να ισχύει καθεστώς συλλεκτικού οχήματος",
      classic: "Σε ορισμένες περιοχές μπορεί να ισχύει κλασική ταξινόμηση",
      standard: "Περιμένετε τυπικές ανανεώσεις και τοπικούς ελέγχους",
      regular: "Συνήθως ισχύει κανονική ταξινόμηση",
    },
    upcomingMilestoneTitle: "Επόμενο ορόσημο",
    milestoneTimelineTitle: "Χρονολόγιο οροσήμων",
    milestoneRemaining: ({ label, days }) => `${label} σε ${days.toLocaleString("el-GR")} ημέρες`,
    reached: "Ολοκληρώθηκε",
    upcoming: "Επόμενο",
    allMilestonesReachedTitle: "Όλα τα αναφερόμενα ορόσημα έχουν επιτευχθεί",
    allMilestonesReachedBody:
      "Αυτό το όχημα έχει ξεπεράσει το εύρος οροσήμων που εμφανίζεται αυτή τη στιγμή στην εφαρμογή.",
    copySummary: "Αντιγραφή περίληψης",
    shareResult: "Κοινοποίηση αποτελέσματος",
    resetMessage: "Ο υπολογιστής επαναφέρθηκε",
    summaryCopied: "Η περίληψη αντιγράφηκε στο πρόχειρο",
    clipboardFailed: "Η πρόσβαση στο πρόχειρο απέτυχε",
    emptyTitle: "Επιλέξτε έτος κατασκευής για να δείτε την πλήρη ανάλυση",
    emptyDescription:
      "Θα δείτε ακριβή ηλικία, συνολικές ημέρες, σημειώσεις συντήρησης, κλασική κατάσταση και χρονισμό οροσήμων μόλις επιλεγεί ένα έτος.",
    shareTitle: "Υπολογιστής Ηλικίας Οχήματος",
    summary: ({ label, years, months, days, asOf }) =>
      `Το όχημά μου έχει ημερομηνία κατασκευής ${label} και έως τις ${asOf} είναι ${years} ετών, ${months} μηνών και ${days} ημερών.`,
    milestones: {
      1: { label: "Πρώτο έτος", note: "Χρήσιμο για εγγύηση και προγραμματισμό σέρβις." },
      3: { label: "Τρία χρόνια", note: "Συνηθισμένο σημείο για μεταπώληση και αλλαγές αξίας." },
      5: { label: "Πέντε χρόνια", note: "Καλή στιγμή για πιο βαθύ προϋπολογισμό συντήρησης." },
      10: { label: "Δέκα χρόνια", note: "Τα παλαιότερα εξαρτήματα θέλουν περισσότερη προσοχή." },
      15: { label: "Δεκαπέντε χρόνια", note: "Σε πολλές περιοχές ξεκινά εδώ η κλασική αντιμετώπιση." },
      25: { label: "Είκοσι πέντε χρόνια", note: "Μπορεί να ενδιαφέρει συλλέκτες και αγορές εισαγωγής." },
    },
  };
